import React from 'react';
import {Box, Button} from '@mui/material';

import {EmptySearchState} from 'presentation/components';
import {useCallChatRoom, useMediaQueries} from 'presentation/pages/private/hooks';
import {DefaultEmptyStateProps} from './types';
import {translations} from 'presentation/translations-new';
import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {ChatRoomsEnum} from 'presentation/constants';
import {Loading} from 'presentation/components/Loading/Loading';
const {clearFilters: clearFiltersText, callToChat} = translations['pt-br'].commons;

function DefaultEmptyState({
	title,
	description,
	internalPadding,
	dataTagId,
	children,
	clearFilters,
	hasCallChatRoom,
	chatRoomType = ChatRoomsEnum.EXAMS,
}: DefaultEmptyStateProps) {
	const {isMobile} = useMediaQueries();
	const {callChatRoom, IS_LOADING: callChatRoomIsLoading} = useCallChatRoom();

	const customPadding = isMobile ? 2 : 4;

	return (
		<Box p={internalPadding ? customPadding : 0}>
			<EmptySearchState title={title} description={description} dataTagId={dataTagId}>
				{children}
				{clearFilters ? (
					<Button
						size="large"
						variant={hasCallChatRoom ? 'contained' : 'outlined'}
						onClick={clearFilters}>
						{clearFiltersText}
					</Button>
				) : null}
				{hasCallChatRoom ? (
					<Button
						size="large"
						variant="outlined"
						data-tag-id={AppointmentBookingEnum.CLICK_FALAR_COM_ATENDIMENTO_AGENDAMENTO}
						onClick={async () => await callChatRoom(chatRoomType)}
						disabled={callChatRoomIsLoading}
						endIcon={
							callChatRoomIsLoading ? <Loading size={16} color="inherit" /> : null
						}>
						{callToChat}
					</Button>
				) : null}
			</EmptySearchState>
		</Box>
	);
}

export {DefaultEmptyState};
